import { useEffect, useState } from "react";

import { getPasswordSecurityVerifications } from "Helpers/Password";

import * as S from "./styles";

const SafePassword = ({ password }) => {
  const [verifications, setVerifications] = useState({});

  useEffect(() => {
    setVerifications(getPasswordSecurityVerifications(password));
  }, [password]);

  return (
    <S.SafePassword>
      Certifique-se de{" "}
      <S.ColorFulSpan valid={verifications.hasEnoughLength}>
        pelo menos 8 caracteres
      </S.ColorFulSpan>
      ,{" "}
      <S.ColorFulSpan valid={verifications.hasNumber}>
        incluindo números
      </S.ColorFulSpan>
      ,{" "}
      <S.ColorFulSpan valid={verifications.hasUppercase}>
        letra maiúscula{" "}
      </S.ColorFulSpan>
      e{" "}
      <S.ColorFulSpan valid={verifications.hasSpecialCharacters}>
        caracteres especiais como “@” ou “*”
      </S.ColorFulSpan>
      .
    </S.SafePassword>
  );
};

export default SafePassword;
